import Backbone from 'backbone';
import dustjs from 'dustjs';
import validator from 'validator';
import _rangeFacetDust from 'common/_range_facet.dust';

export const RangeFacetModel = Backbone.Model.extend({
	validate(attributes) {
		const errors = [];
		const minValid = validator.isDecimal(`${attributes.selectedMin}`);
		const maxValid = validator.isDecimal(`${attributes.selectedMax}`);
		if (!minValid) {
			errors.push({ field: 'selectedMin', message: 'Low value is invalid. Please enter numbers without commas.' });
		}
		if (!maxValid) {
			errors.push({ field: 'selectedMax', message: 'High value is invalid. Please enter numbers without commas.' });
		}
		if (minValid && maxValid && attributes.selectedMin > attributes.selectedMax) {
			errors.push({ field: 'selectedMax', message: 'High value cannot be smaller than low value.' });
			errors.push({ field: 'selectedMin', message: 'High value cannot be smaller than low value.' });
		}
		if (errors.length) {
			return { message: errors[0].message, focusField: errors[0].field, fields: errors.map((error) => error.field) };
		}
	}
});

export const RangeFacetView = Backbone.View.extend({
	events: {
		'click .js-apply-range-facet-values': '_applyRangeFacetValues',
		'change .js-min-input': '_setRangeFacetMin',
		'change .js-max-input': '_setRangeFacetMax'
	},

	errorClass: 'b--theme-error',

	_defaultSettings() {
		return {
			min: 0,
			max: 1000,
			selectedMin: 0,
			selectedMax: 1000,
			hideButton: false,
			onChange: () => {},
			onApply: () => {}
		};
	},

	initialize(options = {}) {
		this.options = Object.assign(this._defaultSettings(), options);
		this.model = new RangeFacetModel(this.options);
		this.model.on('invalid', this._handleInvalidModel.bind(this));
	},

	_handleInvalidModel(model, error) {
		window.BCOM.notifications.render(error.message, 'danger');

		if (error.focusField === 'selectedMin') {
			this.$minInput.focus();
		} else if (error.focusField === 'selectedMax') {
			this.$maxInput.focus();
		}
	},

	render() {
		const selectedMin = parseFloat(this.model.get('selectedMin'));
		const selectedMax = parseFloat(this.model.get('selectedMax'));
		const templateModel = {
			min: !isNaN(selectedMin) ? selectedMin : this.model.get('min'),
			max: !isNaN(selectedMax) ? selectedMax : this.model.get('max'),
			hideButton: this.options.hideButton,
			BCOM: window.BCOM
		};
		dustjs.render(_rangeFacetDust, templateModel, (error, markup) => {
			this.$el.html(markup);
			this._setElements();
		});
		return this;
	},

	_setElements() {
		this.$minInput = this.$('.js-min-input');
		this.$maxInput = this.$('.js-max-input');
	},

	_setRangeFacetMin(e) {
		this._onFacetChange([e.currentTarget.value, this.model.get('selectedMax')]);
	},

	_setRangeFacetMax(e) {
		this._onFacetChange([this.model.get('selectedMin'), e.currentTarget.value]);
	},

	_isValidValue(value) {
		return validator.isDecimal(`${value}`);
	},

	_onFacetChange(values) {
		const currentMin = this.model.get('selectedMin'),
			currentMax = this.model.get('selectedMax'),
			min = values[0],
			max = values[1],
			selectedMin = this._isValidValue(min) ? this._parseValue(min, Math.floor) : null,
			selectedMax = this._isValidValue(max) ? this._parseValue(max, Math.ceil) : null;

		this.model.set({ selectedMin, selectedMax });

		if (this.model.isValid()) {
			this.$minInput.removeClass(this.errorClass);
			this.$maxInput.removeClass(this.errorClass);

			if (this.options.onChange && (currentMax !== selectedMax || currentMin !== selectedMin)) {
				this.options.onChange(selectedMin, selectedMax);
			}
		}
	},

	_parseValue(value, roundingFunc) {
		if (typeof value !== 'string') {
			return value;
		}
		return roundingFunc(parseFloat(value));
	},

	_updateMinMaxFacetTextInputs(values) {
		this.$minInput.val(values[0]);
		this.$maxInput.val(values[1]);
	},

	resetValues() {
		const values = [this.model.get('min'), this.model.get('max')];
		this._updateMinMaxFacetTextInputs(values);
	},

	setValues(min, max) {
		this._updateMinMaxFacetTextInputs([min, max]);
	},

	_applyRangeFacetValues() {
		const isValid = this.model.isValid();
		if (typeof this.options.onApply === 'function' && isValid) {
			this.options.onApply(this.model.get('selectedMin'), this.model.get('selectedMax'));
		}
	}
});
